import { useOktaAuth } from '@okta/okta-react';

const useAuth = () => {
  return useOktaAuth();
};

export default useAuth;
